import { createContext } from "react"

export interface SplashScreenContextType {
  isVisible: boolean
  hideSplash: () => void
}

export const SplashScreenContext = createContext<SplashScreenContextType>({
  isVisible: true,
  hideSplash: () => {},
})
